import { useCallback } from 'react';
import { useFormikContext } from 'formik';
import get from 'lodash/get';

import getNamespacedFieldName from './getNamespacedFieldName';

const useFormikFieldsResetCallback = (fieldNamesArray, namespace) => {
  const { initialValues, setFieldValue } = useFormikContext();

  return useCallback(() => {
    if (!Array.isArray(fieldNamesArray)) {
      console.error(
        `You must provide an array of field names. You provided "${String(
          JSON.stringify(fieldNamesArray)
        )}"`
      );
      return;
    }
    fieldNamesArray.forEach(rawName => {
      const name = getNamespacedFieldName(rawName, namespace);
      setFieldValue(name, get(initialValues, name));
    });
  }, [fieldNamesArray, namespace, initialValues, setFieldValue]);
};
export default useFormikFieldsResetCallback;
